function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#AEFF00;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#16161A;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M59.2,18.2c1,0,1.8-0.8,1.8-1.8v-2.8c0-2.5-1.3-4.8-3.2-6.1c0.5-0.8,0.8-1.7,0.8-2.7c0-2.7-2.2-4.9-4.9-4.9 s-4.9,2.2-4.9,4.9c0,1,0.3,1.9,0.8,2.7c-1.9,1.3-3.2,3.6-3.2,6.1v1.8l-5.1,3.4c-2.8-2.6-6.6-4.2-10.7-4.2s-7.9,1.6-10.7,4.2 l-5.1-3.4v-1.8c0-2.5-1.3-4.8-3.2-6.1c0.5-0.8,0.8-1.7,0.8-2.7C12.2,2.2,10,0,7.3,0C4.6,0,2.4,2.2,2.4,4.9c0,1,0.3,1.9,0.8,2.7 C1.3,8.9,0,11.1,0,13.6v2.8c0,1,0.8,1.8,1.8,1.8h10.6l5.1,3.4c-1.8,2.6-2.8,5.6-2.8,9s1,6.4,2.8,9L12,43.1L10.6,44 c-0.9-0.8-2-1.2-3.2-1.2c-2.7,0-4.9,2.2-4.9,4.9c0,1,0.3,1.9,0.8,2.7C1.3,51.7,0,53.9,0,56.4v2.8c0,1,0.8,1.8,1.8,1.8h11.2 c1,0,1.8-0.8,1.8-1.8v-2.8c0-2.5-1.3-4.8-3.2-6.1c0.5-0.8,0.8-1.7,0.8-2.7c0-0.2,0-0.4,0-0.6l7.6-5c2.8,2.6,6.6,4.2,10.7,4.2 s7.9-1.6,10.7-4.2l7.6,5c0,0.2,0,0.4,0,0.6c0,1,0.3,1.9,0.8,2.7c-1.9,1.3-3.2,3.6-3.2,6.1v2.8c0,1,0.8,1.8,1.8,1.8h11.2 c1,0,1.8-0.8,1.8-1.8v-2.8c0-2.5-1.3-4.8-3.2-6.1c0.5-0.8,0.8-1.7,0.8-2.7c0-2.7-2.2-4.9-4.9-4.9c-1.2,0-2.4,0.5-3.2,1.2L49,43.1 l-5.5-3.6c1.8-2.6,2.8-5.6,2.8-9s-1-6.4-2.8-9l5.1-3.4L59.2,18.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_1_",
  x: 24,
  y: 23,
  width: 13,
  height: 16
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  className: "st1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M35.4,27.3c-0.1-0.6-0.2-1.2-0.5-1.7c-0.9-1.5-2.1-2.4-3.8-2.6c-0.9-0.1-1.9,0-2.7,0.4 c-1.3,0.6-2.3,1.6-2.7,3.1c-0.1,0.3-0.1,0.5-0.2,0.8c0,0-0.1,0-0.1,0c-0.3-0.1-0.6-0.1-0.9-0.1C24.3,27.4,24,27.7,24,28 c0,0.2,0.1,0.4,0.2,0.6c0.1,0.1,0.2,0.3,0.3,0.4c0.3,0.4,0.6,0.9,0.9,1.3c0.1,0.2,0.2,0.4,0.2,0.6c0,0.4,0,0.7,0,1.1 c-0.1,0.5,0,1,0,1.5c0.1,0.6,0.3,1.1,0.6,1.6c0,0,0,0,0,0.1c0.1,0.1,0.1,0.1,0.2,0c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.2-0.1,0.3,0 c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.1,0.1,0.3,0.2,0.4c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.1,0.3-0.1,0.4,0.1 c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.3,0.6,0.4,0.9c0.1,0.2,0.2,0.4,0.3,0.6l0,0c0,0,0-0.1,0-0.1c0-0.2,0.1-0.3,0.1-0.5 c0.2-0.3,0.5-0.4,0.8-0.1c0.1,0.1,0.2,0.3,0.3,0.5c0.2,0.4,0.3,0.8,0.3,1.3c0,0.1,0,0.1,0,0.2l0,0c0-0.1,0.1-0.1,0.1-0.2 c0.2-0.4,0.4-0.7,0.5-1.1c0.1-0.2,0.3-0.3,0.5-0.2c0.1,0,0.1,0,0.2,0.1c0.1-0.4,0.3-0.7,0.6-0.9c0.2-0.2,0.4-0.2,0.5,0.1 c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1,0.1,0.1c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0.1-0.4,0.2-0.7,0.4-1.1 c0.1-0.2,0.3-0.2,0.4,0c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0-0.1c0.5-0.7,0.7-1.4,0.7-2.3c0-0.7,0-1.3,0-2 c0-0.4,0.1-0.7,0.3-1c0.3-0.4,0.6-0.9,1-1.3c0.1-0.2,0.2-0.4,0.2-0.6c0.1-0.4,0-0.6-0.4-0.8c-0.1,0-0.3-0.1-0.4-0.1 C35.9,27.3,35.7,27.3,35.4,27.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M32.5,28c0.6,0,1-0.5,0.9-1.1c0-0.2-0.1-0.3-0.3-0.2c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.1,0.1-0.2,0.1 C32,27.4,32,27.6,32,27.8c0.1,0.2,0.2,0.2,0.4,0.2C32.5,28,32.5,28,32.5,28z M28.4,28c0,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.3,0-0.6-0.3-0.7c-0.3-0.1-0.5-0.2-0.8-0.3c-0.2-0.1-0.3,0-0.3,0.2C27.4,27.6,27.7,28.1,28.4,28L28.4,28z"
}));

function SvgVeteransIconGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61 61",
    style: {
      enableBackground: "new 0 0 61 61"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", null, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _ref5));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteransIconGreen);
export default __webpack_public_path__ + "static/media/veteransIcon-green.c6b5b72795a0c9969fab9f9245f13a3c.svg";
export { ForwardRef as ReactComponent };